// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prd.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular.json`.

// appVersionRaw is derived from the Git tag at build time via scripts/set-app-version.js,
// which regenerates app-version.generated.ts in CI. The committed generated value is the
// local-dev default, refreshed when production is merged into development.
// See docs/deployment/version-automation.md.
import { appVersionRaw, sentryReleaseJepto } from './app-version.generated';

export const environment = {
	production: false,
	staging: false,
	develop: true,
	hostName: 'https://dev.jepto.com',
	apiBaseURL: 'https://dev.api.app.jepto.com',
	appSyncConfig: {
		graphqlEndpoint:
			'https://tufmdjuj3nfelf4xekkm5d3jz4.appsync-api.ap-southeast-1.amazonaws.com/graphql',
		customEndpoint: 'https://dev.api.app.jepto.com/graphql',
		eventsEndpoint: 'https://dev.event.jepto.com',
		region: 'ap-southeast-1',
		authenticationType: 'AMAZON_COGNITO_USER_POOL',
	},
	cognitoSettings: {
		UserPoolId: 'ap-southeast-1_2peJmBtUq',
		ClientId: '7jkdas9ekeminjq171u6v91uvi',
	},
	REST_API: {
		accountSignUp: 'https://dev.api.app.jepto.com/users/sign-up',
	},
	stripeAPI: 'pk_test_hDhP0cqaWutez6zsUiXFf1SL',
	appVersionRaw,
	sentryRelease: sentryReleaseJepto,
	key: 'dev',
	orttoAPIKEY: 'YyPK1glZJOMv0wWFamVwdG90ZXN0',
	imgUpload: 'https://dev.api.app.jepto.com/media',
	algolia: {
		appId: 'K7WR0PXEBL',
		searchApiKey: '422196138fd6f5d7bb616928df234231',
		writeApiKey: '9c8e0c4b9de454ac5c244e93722c10c9',
		indexName: 'storybook',
	},
	chargebee: {
		site: 'jepto-test',
		publishableKey: 'test_oTPmwATLunPATP112Gs9VojmcduQR2acde',
		// Payment intent expiry configuration (in milliseconds)
		expiryBufferMs: 60 * 1000, // 1 minute buffer before considering intent expired
		warningTimeMs: 5 * 60 * 1000, // 5 minutes before expiry to show warning
		proactiveRefreshMs: 2 * 60 * 1000, // 2 minutes before expiry to trigger refresh
	},
	reportchatAPI: {
		apiURL: 'https://dev.report.jepto.com',
	},
	reportSummaryAPI: {
		invocationsURL: 'https://dev.analysis.jepto.com',
	},
	/** Public analytics viewer host for report share links (`/{reportId}`). Not the report runtime API. */
	reportSharePublicOrigin: 'https://dev.jep.to',
	datachatAPI: {
		apiURL: 'https://dev.ai.jepto.com',
		fileUploadAPI: 'https://dev.upload.jepto.com',
		chatMessageChannel: {
			endpoint: 'https://dev.event.jepto.com',
			region: 'ap-southeast-1',
			defaultAuthMode: 'userPool',
		},
	},
	frillAPI: {
		key: 'f4050e2c-8408-470f-a910-b2b20d23a527',
		widgetKey: 'widget_xHT4MA_jClJvC',
	},
	sentry: {
		enabled: false,
		dsn: 'https://8e1015b0ec9f951c71174f29875beac5@o4510870850437120.ingest.us.sentry.io/4510871488888832',
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
		debug: false,
	},
	googleDrivePicker: {
		apiKey: '',
		clientId: '',
		appId: '',
	},
	chromatic: {
		projectToken: '',
	},
	/** Highcharts Grid Pro key — https://www.highcharts.com/docs/grid/grid-key */
	highchartsGridKey: '',
};
